import { SHOW_LOADER, SET_ALERT } from "../actions/mainActions";


const initialState: MainReducerState = {
    show_loader: false,
    alert: null
}

const mainReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SHOW_LOADER:
            return {
                ...state,
                show_loader: action.value
            }
        case SET_ALERT:
            return {
                ...state,
                alert: action.value
            }
        default:
            return state;
    }
}

export interface MainReducerState {
    show_loader: boolean;
    alert: GlobalAlert | null;
}

export interface GlobalAlert{
    s: string;
    message: string;
    ok: Function;
}

export default mainReducer;